import { Component, EventEmitter, Output, ViewEncapsulation, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { ContentStateService } from '../../content/content-state.service';
import { SearchResultsComponent } from '../../content/searcher/search-results/search-results.component';

@Component({
  selector: 'app-questions-search-view',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, TranslateModule, SearchResultsComponent],
  templateUrl: './questions-search-view.component.html',
  styleUrls: ['./questions-search-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class QuestionsSearchViewComponent {
  public sidenavService = inject(SidenavService);
  private contentStateService = inject(ContentStateService);
  results = this.contentStateService.searchResults;
  @Output() close = new EventEmitter<void>();

  closeView() {
    this.close.emit();
  }
}
